import { useMutation } from '@tanstack/react-query';
import { downloadFiles } from 'further-ui/utils';
import { useNotification } from './useNotification';

const useDownloadFiles = ({
  errorMessage = 'Files are not available for download, please try again later.',
}: { errorMessage?: string } = {}) => {
  const { error } = useNotification();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({
      files,
      fileName,
    }: {
      files: Array<{ url: string; name: string }>;
      fileName: string;
    }) => {
      await downloadFiles(files, fileName);
    },
    onError: () => {
      error(errorMessage);
    },
  });

  return {
    downloadFiles: mutate,
    isPending,
  };
};

export default useDownloadFiles;
